import { Component, Input, type OnInit, HostBinding } from '@angular/core';
import { CleanStringPipe } from '@app/common/pipes/clean-string.pipe';

@Component({
  selector: 'app-user-image',
  imports: [CleanStringPipe],
  templateUrl: './user-image.component.html',
  styleUrl: './user-image.component.scss',
})
export class UserImageComponent implements OnInit {

  @Input() firstname: string = '';
  @Input() lastname: string = '';
  @HostBinding('class.tooltip') @Input() tooltip: string | null = null;

  ngOnInit(): void {
  }
}
